import { IBlockerSetAction } from './types';
import { AT_BLOCKER_SET } from './constants';

export const blockerSet = (
    isBlocked: boolean
): IBlockerSetAction => ({
    type: AT_BLOCKER_SET,
    isBlocked
});
